import React, { useContext } from 'react'
import { LanguageContext } from '../../container/Language'
import Tags from './Tags'
import Works from './Works'

const Work = () => {
    const { dictionary: { works: { title, tags, items } } } = useContext(LanguageContext)
    return (
        <div className="card-inner" id="works-card">
            <div className="card-wrap">

                <div className="content works">

                    <div className="title">{title.projectTitle}</div>

                    <Tags items={tags} />

                    <div className="row grid-items border-line-v">

                        <Works items={items} title={title} />

                        <div className="clear"></div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default Work